import React, { useState, useEffect } from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Api from '../../../api/global.service';
import mapChartData from '../../../utils/mapChartData.js';
import renderCustomizedLabel from '../../../utils/renderCustomizedLabel.js';
import BlockUi from 'react-block-ui';

import useEtiquetas from '../../../hooks/useEtiquetas';
import transformWord from '../../../utils/transformWord';

const ParcelasResumenEspecies = ({ id_ciclo }) => {
  const [dataGrafica, setDataGrafica] = useState([]);
  const [blocking, setBlocking] = useState(true);
  const { etiquetas } = useEtiquetas();

  useEffect(() => {
    if (id_ciclo > 0) {
      getData();
    }
  }, [id_ciclo]);

  const getData = () => {
    setBlocking(true);
    Api.search('dashboards/apiarios/especies', {
      filter: [{ column: 'id_ciclo', operator: '=', value: id_ciclo }],
    }).then(response => {
      let chartData = mapChartData(response.data, 'tipo', 'total');
      setDataGrafica(chartData);
      setBlocking(false);
    }).catch(() => {
      setDataGrafica([]);
      setBlocking(false);
    });
  };

  return (
    <BlockUi tag="div" message="" blocking={blocking} renderChildren={true} style={{ height: '95%' }}>
      <div className="row p-10 mt-2" style={{ backgroundColor: '#F3EFEC', margin: 10, borderRadius: 10, height: '100%' }}>
        <p className="dashboard-titulo-grafica">Especies de flores en {transformWord(etiquetas?.parcela, ['plural','lowercase'])}:</p>
        <div className="col-xl-12 col-md-12">
          <ResponsiveContainer width="100%" height={250}>
            <PieChart width={500} height={false}>
              <Pie
                data={dataGrafica}
                labelLine={false}
                label={renderCustomizedLabel}
                outerRadius={100}
                fill="#8884d8"
                dataKey="value"
                isAnimationActive={false}>
                {dataGrafica.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip />
              <Legend layout="horizontal" verticalAlign="bottom" align="center" />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </BlockUi>
  );
};

export default ParcelasResumenEspecies;
